import React from 'react';
import _ from 'platform/utilities/data';
import { validateFileField } from 'platform/forms-system/src/js/validation';
import { HINT_TEXT } from '../../shared/components/fileInputComponent/FileInputComponentV1';
import { additionalInfo } from '../../shared/components/fileInputComponent/AdditionalUploadInfo';
import { ancillaryFormUploadUi } from '../../shared/utils/schemas';
import { standardTitle } from '../content/form0781';

const fileUploadUi = ancillaryFormUploadUi('', '', {
  attachmentId: '',
  addAnotherLabel: 'Add another file',
  buttonText: 'Upload file',
});

const strDescription = (
  <>
    <p>
      Upload copies of your service treatment records to support your claim.
    </p>
    {additionalInfo}
    <p className="vads-u-font-weight--normal vads-u-margin-bottom--0">
      Select a file to upload
      <span className="schemaform-required-span vads-u-font-family--sans vads-u-font-size--base vads-u-font-weight--normal">
        (*Required)
      </span>
    </p>
  </>
);
export const uiSchema = {
  'ui:title': standardTitle('Upload your service treatment records'),
  'ui:description': strDescription,
  // 'view:uploadServiceTreatmentRecordsQualifier'
  serviceTreatmentRecordsAttachments: {
    ...fileUploadUi,
    'ui:options': { ...fileUploadUi['ui:options'] },
    'ui:description': HINT_TEXT,
    'ui:errorMessages': {
      ...fileUploadUi['ui:errorMessages'],
      required: 'Upload at least one file',
    },
    'ui:confirmationField': ({ formData }) => ({
      data: formData?.map(item => item.name || item.fileName),
      label: 'Uploaded file(s)',
    }),
    'ui:required': data =>
      _.get(
        'view:uploadServiceTreatmentRecordsQualifier.view:hasServiceTreatmentRecordsToUpload',
        data,
        false,
      ),
    'ui:validations': [validateFileField],
  },
};

export const schema = {
  type: 'object',
  properties: {
    serviceTreatmentRecordsAttachments: {
      minItems: 1,
      type: 'array',
      items: {
        type: 'object',
        required: ['name', 'attachmentId'],
        properties: {
          name: {
            type: 'string',
          },
          confirmationCode: {
            type: 'string',
          },
          attachmentId: {
            type: 'string',
            enum: ['L450', 'L451'],
            enumNames: [
              'STR - Dental - Photocopy',
              'STR - Medical - Photocopy',
            ],
          },
        },
      },
    },
  },
};
